import { render, staticRenderFns } from "./DeleteDropdown.vue?vue&type=template&id=30baae94&"
import script from "./DeleteDropdown.vue?vue&type=script&lang=js&"
export * from "./DeleteDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports